(function($) {

	$.fn.initHistory = function() {

		var _this = this;

		_this.find(".item").addClass("preparing").each(function() {
			var $this = $(this);
			$this.waypoint(
				function() {
					$this.removeClass("preparing");
				},
				{
					offset: function() {
						var vh = Waypoint.viewportHeight();
						var h = $this.height();
						if (h <= vh / 2) {
							return  vh - (h * 0.75);
						}
						return vh - 250;
					}
				}
			);
		});

		window.setTimeout(function() {
			_this.addClass("animated");
		}, 50);

		return this;

	}

})(jQuery);
